import React from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useRouteMatch, Switch, Route } from 'react-router'
import GscApplication from './GscApplications'
import GscReturn from './GscReturn'
import AddChequeDetails from '../AddChequeDetails'

const Gsc = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="Gsc">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="Gsc">GSC Applications</Nav.Link>
              </Nav.Item>
              <Nav.Item className="custom-nav-item">
                <Nav.Link eventKey="Gsc-return">GSC Return</Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row className="page-tiles-layout">
            <Tab.Content>
              <Tab.Pane eventKey="Gsc">
                <GscApplication />
              </Tab.Pane>
              <Tab.Pane eventKey="Gsc-return">
                <GscReturn />
              </Tab.Pane>
            </Tab.Content>
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/add/:id`}
        render={(props) => <AddChequeDetails scheme={'GSC'} {...props} />}
      />
    </Switch>
  )
}

export default Gsc
